import { styled } from "@volkswagen-onehub/components-core";
import React from "react";
import useFiltersCountQuery from "../api/use-filters-count-query";
import useFiltersQuery from "../api/use-filters-query";
import { FilterBarSkeleton } from "./FilterBarSkeleton";
import { MoreFiltersButton } from "./MoreFiltersButton";
import { QuickFilters } from "./QuickFilters";
import { SelectedFilters } from "./SelectedFilters";

const Wrapper = styled.div`
  margin-top: 0;
  max-width: 1750px;
  @media (min-width: 560px) {
    margin-left var(--size-grid002);
    margin-right var(--size-grid002);
  }
  * {
    scroll-margin-bottom: 100px;
    scroll-margin-top: 124px;
  }
`;

const Container = styled.div`
  display: flex;
  -moz-box-align: center;
  align-items: center;
  position: relative;
  white-space: nowrap;
  overflow-x: scroll;
  scrollbar-width: none;
  column-gap: 8px;
  padding: 2px;
  mask-image: linear-gradient(to right, black 80%, transparent);
  > :first-child {
    margin-inline-start: var(--size-grid002);
  }
  > :last-child {
    margin-inline-end: var(--size-grid002);
  }

  @media (min-width: 560px) {
    display: flex;
    flex-wrap: wrap;
    overflow-x: hidden;
    row-gap: 16px;
    mask-image: none;
    > :first-child {
      margin-inline-start: 0;
    }
  }
`;

export const FilterBar = () => {

  const { isLoading: areFiltersLoading } = useFiltersQuery();
  const { isLoading: isFiltersCountLoading } = useFiltersCountQuery();

  const isLoading = areFiltersLoading && isFiltersCountLoading;

  return (
    <Wrapper>
      <Container>
        {
          isLoading
          ? <FilterBarSkeleton />
          : <>
            <QuickFilters />
            <SelectedFilters />
            <MoreFiltersButton />
          </>
        }
      </Container>
    </Wrapper>
  );
};
